// extracted by mini-css-extract-plugin
export default {"detail_container":"detail_detail_container__d5Gs6","detail_mainContainer":"detail_detail_mainContainer__wgXMr","details":"detail_details__36Jl2"};